import { Box, Grid } from '@mui/material';
import { User } from '@thro-types/users';

import React from 'react';

import Profile from './Profile';

interface Props extends React.PropsWithChildren<{}> {
  className?: string;
  heading?: string;
  renderHeading: () => JSX.Element;
  user?: User;
}

export const DesktopMenuBar = ({ className, heading, renderHeading, user }: Props) => {
  return (
    <Grid container className="container__heading">
      <Box className="container__heading__title">{heading && renderHeading()}</Box>
      {user && (
        <Grid item xs>
          <Profile user={user} />
        </Grid>
      )}
    </Grid>
  );
};
